import { createBrowserRouter } from "react-router-dom";
import { Suspense, lazy, type ReactNode } from "react";
import { AppShell } from "@/components/layout/AppShell";
import { MatchGridSkeleton } from "@/components/common/Skeletons";

// Routes are code-split so the live dashboard (the most-visited screen) never
// waits on the player/lineups/commentary bundles for other pages.
const HomePage = lazy(() => import("@/pages/HomePage"));
const SchedulePage = lazy(() => import("@/pages/SchedulePage"));
const MatchDetailPage = lazy(() => import("@/pages/MatchDetailPage"));
const LeaguesPage = lazy(() => import("@/pages/LeaguesPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

function RouteFallback({ children }: { children: ReactNode }) {
  return <Suspense fallback={<MatchGridSkeleton />}>{children}</Suspense>;
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <RouteFallback><HomePage /></RouteFallback> },
      { path: "schedule", element: <RouteFallback><SchedulePage /></RouteFallback> },
      { path: "leagues", element: <RouteFallback><LeaguesPage /></RouteFallback> },
      { path: "match/:matchId", element: <RouteFallback><MatchDetailPage /></RouteFallback> },
      { path: "*", element: <RouteFallback><NotFoundPage /></RouteFallback> },
    ],
  },
]);
